import axios from "axios";

const post = (params) => {
  return axios.post('authenticate', params);
};

export default {
  post
};